<template>
  <b-card>
    <template #header> 
      <b-button 
        class="float-right"
        variant=""
        @click="reversed = !reversed"
      >
        <i class='bx' :class="{'bx-sort-up': reversed, 'bx-sort-down': !reversed}" ></i>
      </b-button>
      <i class='bx bx-list-ul' />
      {{$t('common.activity')}}
    </template>
    <div v-if="events">
      <dl>
        <value 
          v-for="(event,i) in sortedEvents" 
          :key="i" 
          :raw-label="event.date | moment('LLLL')" 
          :icon="getIcon(event)"
          :value="true"
        >
          <template v-if="event.type === 'status'">
            {{$t(`common.status`)}}: <status v-bind="{item}" :value="event.data" />
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span>
          </template>
          <template v-else-if="event.type === 'bringoz'">
            {{$t(`${resource.plural}.events.bringoz`,{status: $t(`${event.data}`)})}}
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: 'Bringoz'})}}</span>
          </template>
          <template v-else-if="event.type === 'notification-sms'">
            {{$t(`events.notification-sms`)}}
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span><br>
            <span class="text-initial">{{$t(`${resource.plural}.events.notification.${event.data}`)}}</span>
          </template>
          <template v-else-if="event.type === 'notification-email'">
            {{$t(`events.notification-email`)}}
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span><br>
            <span class="text-initial">{{$t(`${resource.plural}.events.notification.${event.data}`)}}</span>
          </template>
          <template v-else-if="event.type === 'notification-whatsapp'">
            {{$t(`events.notification-whatsapp`)}}
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span><br>
            <span class="text-initial">{{$t(`${resource.plural}.events.notification.${event.data}`)}}</span>
          </template>
          <template v-else-if="event.type === 'notification-failed'">
            <span class="text-danger">{{$t(`events.notification-failed`)}} </span>
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span><br>
            <span class="text-initial">{{event.data}}</span>
          </template>
          <template v-else-if="event.type === 'notification-failed-sms'">
            <span class="text-danger">{{$t(`events.notification-failed-sms`)}} </span>
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span><br>
            <span class="text-initial">{{event.data}}</span>
          </template>
          <template v-else-if="event.type === 'notification-failed-email'">
            <span class="text-danger">{{$t(`events.notification-failed-email`)}} </span>
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span><br>
            <span class="text-initial">{{event.data}}</span>
          </template>
          <template v-else-if="event.type === 'notification-failed-whatsapp'">
            <span class="text-danger">{{$t(`events.notification-failed-whatsapp`)}} </span>
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span><br>
            <span class="text-initial">{{event.data}}</span>
          </template>
          <template v-else-if="event.type === 'batch-email-notified'">
            {{$t(`batch_items.events.email-notified`)}}
          </template>
          <template v-else-if="event.type === 'batch-sms-notified'">
            {{$t(`batch_items.events.sms-notified`)}}
          </template>
          <template v-else-if="event.type === 'batch-email-reminded'">
            {{$t(`batch_items.events.email-reminded`)}}
          </template>
          <template v-else-if="event.type === 'batch-sms-reminded'">
            {{$t(`batch_items.events.sms-reminded`)}}
          </template>
          <template v-else-if="event.type === 'batch-email-failed'">
            <span class="text-danger">{{$t(`batch_items.events.email-failed`)}} </span>
            <div class="text-initial">{{event.data}}</div>
          </template>
          <template v-else-if="event.type === 'batch-sms-failed'">
            <span class="text-danger">{{$t(`batch_items.events.sms-failed`)}} </span>
            <div class="text-initial">{{event.data}}</div>
          </template>
          <template v-else-if="event.type === 'shipment-paid'">
            <span class="text-success">{{$t(`shipments.events.paid`)}} </span>
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span>
          </template>
          <template v-else>
            {{$te(`${resource.plural}.events.${event.type}`) ? $t(`${resource.plural}.events.${event.type}`,event) : event.type}}
            <span v-if="event.user" class="text-muted">{{$t(`events.by`,{user: event.user})}}</span>
            <div v-if="event.data" class="text-initial">{{event.data}}</div>
          </template>
        </value>
      </dl>
      <span v-if="item.updated_at" class="small muted">
        {{$t('common.updated_at')}}:
        {{item.updated_at | moment('LLLL')}}
      </span>
    </div>
    <dl v-else>
      <value label="common.created_at" icon="bxs-circle" :value="item.created_at | moment('LLLL')" />
      <value label="common.updated_at" icon="bxs-circle" :value="item.updated_at | moment('LLLL')" />
    </dl>
    <slot />
  </b-card>
</template>

<script>
import Value from "@/components/Value";
import Status from "@/components/Status";
import Resource from '@/services/Resource';

export default {
  components: {Value,Status},
  props: {
    item: {
      type: Resource,
      required: true
    }
  },
  computed: {
    resource() {
      return this.item.constructor
    },
    events() {
      if('events' in this.item.$meta) {
        return this.item.$meta.events
      } else {
        return null
      }
    },
    sortedEvents() {
      return this.reversed ? Object.assign([], this.events).reverse() : this.events
    },
    reversed: {
      get () {
        return this.$store.state.activitiesReversed
      },
      set (reversed) {
        this.$store.commit(`setActivitiesReversed`, reversed)
      },
    },
  },
  methods: {
    getIcon(event)  {
      switch(event.type) {
        case 'created':
          return 'bxs-star'
        case 'status':
          return 'bxs-analyse'
        case 'bringoz':
          return 'bxs-truck'
        case 'notification':
          return 'bxs-notification'
        case 'notification-sms':
          return 'bxs-message-rounded-detail'
        case 'notification-email':
          return 'bxs-envelope'
        case 'notification-whatsapp':
          return 'bxl-whatsapp'
        case 'responded':
          return 'bxs-edit-alt'
        case 'batch-email-notified':
        case 'batch-email-reminded':
          return 'bxs-envelope'
        case 'batch-sms-notified':
        case 'batch-sms-reminded':
          return 'bxs-message-rounded-detail'
        case 'batch-email-failed':
        case 'notification-failed-email':
          return 'bx-envelope text-danger'
        case 'batch-sms-failed':
          case 'notification-failed-sms':
          return 'bx-message-rounded-detail text-danger'
        case 'notification-failed':
          return 'bx-error text-danger'
        case 'rerouted':
          return 'bxs-direction-right'
        case 'shipment-paid':
          return 'bx-coin'
        case 'expiry-extended':
          return 'bx-calendar-plus'
        default:
          return 'bxs-circle'
      }
    }
  }
}
</script>